import { defineMessage } from 'react-intl';
const SHORTCUT_GROUP_META = {
    general: {
        label: defineMessage({
            defaultMessage: 'General',
            description: 'Section heading for general keyboard shortcuts in the shortcuts modal',
            id: '3ba86c0b94',
        }),
        order: 0,
    },
    navigation: {
        label: defineMessage({
            defaultMessage: 'Navigation',
            description: 'Section heading for navigation keyboard shortcuts in the shortcuts modal',
            id: '2db95e1447',
        }),
        order: 1,
    },
    interface: {
        label: defineMessage({
            defaultMessage: 'Interface',
            description: 'Section heading for interface keyboard shortcuts in the shortcuts modal',
            id: '1cfd31dc86',
        }),
        order: 2,
    },
};
/**
 * Returns the localized label for a shortcut group.
 */
export function getShortcutGroupLabel(group) {
    return SHORTCUT_GROUP_META[group].label;
}
/**
 * Returns the sort order for a shortcut group (lower = first).
 */
export function getShortcutGroupOrder(group) {
    return SHORTCUT_GROUP_META[group].order;
}
//# sourceMappingURL=shortcutGroups.js.map